import { UserProfile } from '@app-model/user';
import { Component, OnInit, ViewChild } from '@angular/core';

import { Router, RouteConfigLoadStart, ResolveStart, RouteConfigLoadEnd, ResolveEnd } from '@angular/router';
import { SidebarService } from '@app-services/sidebar.service';
import { UserService } from '@app-services/user.service';

@Component({
    selector: 'app-layout-restrict-area',
    templateUrl: './layout-restrict-area.component.html',
    styleUrls: ['./layout-restrict-area.component.scss'],
    standalone: false
})
export class LayoutRestrictAreaComponent implements OnInit {
	moduleLoading: boolean;
  userProfile: UserProfile;
	constructor(public sidebarService: SidebarService, private router: Router, private userService: UserService) {}

	ngOnInit() {
		this.router.events.subscribe(event => {
			if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
				this.moduleLoading = true;
			}
			if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
				this.moduleLoading = false;
			}
		});

    this.userService.getUserProfile().subscribe((userProfile: any) => {
			this.userProfile = userProfile;
      window.sessionStorage.setItem('userCompanyId', this.userProfile.companyId);
		});

	}
}
